import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View, ViewProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type BadgeProps = ViewProps & UnistylesVariants<typeof stylesheet>

const Badge: FC<BadgeProps> = ({ children, size = 'normal', style, ...props }) => {
    const { styles } = useStyles(stylesheet, { size })

    return (
        <View {...props} style={[styles.container, style]}>
            <Typography.Description size={size} font="bold">
                {children}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.YELLOW_400,
        variants: {
            size: {
                normal: {
                    borderRadius: 8,
                    height: 40,
                    minWidth: 40,
                    paddingHorizontal: 10,
                },
                small: {
                    borderRadius: 4,
                    height: 16,
                    minWidth: 16,
                    paddingHorizontal: 4,
                },
            },
        },
    },
})

export default Badge
